import type { PlaybackState } from "@/lib/timeline/playback";

/** Inputs shared by layout-path overlay apply (one playhead tick). */
export interface TimelineLayoutFrame {
  playheadMs: number;
  viewportWidth: number;
  viewportHeight: number;
}

export function buildTimelineLayoutFrame(
  playback: PlaybackState,
  viewportWidth: number,
  viewportHeight: number,
): TimelineLayoutFrame {
  return {
    playheadMs: playback.playheadMs,
    viewportWidth,
    viewportHeight,
  };
}
